import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { Alert } from "antd";
import {
  daysJsFormat,
  iconSwitchStatusControl,
  renderUserName,
  typeSwitchStatusControl,
} from "../../../utils/constants";
import dayjs from "../../../utils/dayjs";
import { http } from "../../../engine/api/http";
import { t } from "i18next";

export const PrestationInterpreteSelector = () => {
  const [interprete, setInterprete] = useState(null);

  const { prestation, loading, interpretesHasSearch } = useSelector(
    state => state.prestation,
  );

  const getUserInterprete = async () => {
    const { data } = await http.get(
      `users/${prestation?.selector?.interprete}`,
    );
    setInterprete(data);
  };

  useEffect(() => {
    if (prestation.selector !== undefined && prestation.selector !== null) {
      getUserInterprete();
    }
  }, [prestation.selector]);

  return interprete !== null ? (
    <div>
      <br />
      <Alert
        // icon={iconSwitchStatusControl(control2.status, 2)}
        message={t("prestationInterpreteSelector.message")}
        description={
          <>
            {t("prestationInterpreteSelector.alert1")}{" "}
            <b>{renderUserName(interprete)}</b>
            {t("prestationInterpreteSelector.alert2")}
          </>
        }
        type={"info"}
        showIcon
        closable={true}
      />
    </div>
  ) : null;
};
